import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { item } from '@scaffold/editor/items';
import { ItemsService } from '@scaffold/services/items.service';
import { SettingsService } from '@scaffold/services/settings.service';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { setting } from '@scaffold/editor/settings';
import { ItemModalComponent } from '@scaffold/editor/item-modal/item-modal.component';
import cloneDeep from 'lodash/cloneDeep';
import { TinyMCEOptions } from '@app/shared/tinymce_options';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';

@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss'],
    standalone: false
})
export class EditorComponent implements OnInit, OnDestroy {
  undos = [];
  last_hovered;
  undoLevel = 0;
  @Input() templates;
  @Input() info;
  settings: setting;
  items_list: item[];
  active = true;
  dialogRef: ScaffoldDialogRef;
  _items;
  resetSubscription;
  //for template chage retaining content
  itemsToFlag: Array<string> = ['text', 'heading', 'image', 'youtube'];
  itemsForTemplate: Array<any> = [];
  extraItemsForTemplate: Array<any> = [];
  @Output() itemsChange = new EventEmitter<any>();
  @Input()
  set items(value) {
    console.log('Set Items', value);
    let initial = true;
    if (this._items) initial = false;
    this._items = value;
    //this.clear();
  }
  get items() {
    return this._items;
  }
  @Input() data: any = {};
  @Output() editorChange = new EventEmitter<any>();
  @Input() parentView: any;
  @Input() parents;
  @Input() itemObject;
  @Input() undoService;
  deleteHandler(item, arr) {
    console.log(item);
    let index = arr.indexOf(item);
    arr.splice(index, 1);
    this.scaffoldChange('delete');
  }

  addHandler(new_item, item, arr) {
    console.log(item);
    let index = arr.indexOf(item);

    arr.splice(index + 1, 0, cloneDeep(new_item));
    //If the new item was added for the extra items list, mark it as used so it doesn't show on when another item is added
    if (
      this.extraItemsForTemplate &&
      this.extraItemsForTemplate.indexOf(new_item) >= 0
    ) {
      console.log('Setting used');
      new_item.used = true;
    }
    this.scaffoldChange('add');
  }

  moveItem() {
    var cur = this.movingItem.getSelection();
    if (cur) {
      let position = this.movingItem.getPosition();
      console.log(cur);
      if (position) {
        position.arr.splice(position.ind, 1);
      }
      if (!this.items) this.items = [];
      this.items.splice(0, 0, cur);
      this.movingItem.setSelection(null);
      this.scaffoldChange();
      //this call forces tinyMCE to re-init the editor
      this.editor.reInit();
    }
  }

  scaffoldChange(type?: string) {
    console.log('CHANGE', type);
    this.itemsChange.emit(this.items);
    if (this.active && type != 'init') {
      console.log('change: ' + type);
      this.editorChange.emit(this.items);
      if (type !== 'text' && type !== 'undo' && type !== 'redo') {
        console.log('add undo');
        setTimeout(() => this.addUndo());
      }
    }
    if (type === 'comment') {
      let sub = this.itemsService.saveData(this.info, this.info.name);
      console.log(sub);
      if (sub) {
        sub.subscribe(d => {
          console.log('complete');
        });
      } else {
        console.log('RETRY');
        setTimeout(t => {
          this.scaffoldChange(type);
        }, 1000);
      }
    }
  }

  constructor(
    private settingsService: SettingsService,
    private itemsService: ItemsService,
    public dialog: ScaffoldDialogService,
    public movingItem: MoveItemService,
    public editor: TinyMCEOptions
  ) {
    settingsService
      .getSettings()
      .subscribe(settings => (this.settings = settings));
    itemsService
      .getItems()
      .subscribe(item_list => (this.items_list = item_list));
  }

  openDialog(): void {
    console.log('Open add Component');
    // this.movingItem.setPropertiesItem(null);
    let settings: any = {
      context: {
        data: {
          list: this.items_list,
          item: { type: 'root' },
          parents: this.parents,
          toCreate: this.extraItemsForTemplate,
        },
      },
    };
    this.dialogRef = this.dialog.open(ItemModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      if (result && (typeof result !== 'string' || result.length > 0)) {
        if (!this.items || !this.items.splice) this.items = [];
        console.log(result, this.extraItemsForTemplate.indexOf(result));
        this.items.splice(0, 0, cloneDeep(result));
        //If the new item was added for the extra items list, mark it as used so it doesn't show on when another item is added

        if (
          this.extraItemsForTemplate &&
          this.extraItemsForTemplate.indexOf(result) >= 0
        ) {
          console.log('Setting used');
          result.used = true;
        }
        this.scaffoldChange('change');
      }
    });
  }

  log(i) {
    console.log(i);
  }

  ngOnInit() {
    this.itemsService.setKeys(this.parentView.keys);
    this.addUndo();

    this.resetSubscription = this.itemsService.registerReset().subscribe(r => {
      if (r == 'reset') this.clear();
    });
  }

  ngOnDestroy() {
    this.active = false;
    this.itemsService.setKeys([]);
    //  setTimeout(() => { this.movingItem.setPropertiesItem(null) });

    if (this.resetSubscription) {
      this.resetSubscription.unsubscribe();
    }
  }

  undo(i?) {
    if (i !== undefined) {
      this.undoLevel = i;
      this.items = cloneDeep(this.undos[i]);
      this.scaffoldChange('undo');
    } else {
      if (this.undoLevel > 0) {
        this.undoLevel--;
        this.items = cloneDeep(this.undos[this.undoLevel]);
        this.scaffoldChange('undo');
        console.log('undo ', this.undos[this.undoLevel]);
      }
    }
  }

  redo() {
    if (this.undoLevel < this.undos.length - 1) {
      this.undoLevel++;
      this.items = cloneDeep(this.undos[this.undoLevel]);
      this.scaffoldChange('redo');
    }
  }

  clear() {
    this.undos = [cloneDeep(this.items)];
    this.undoLevel = 0;
  }

  addUndo() {
    if (this.undoLevel + 1 < this.undos.length)
      this.undos.splice(this.undoLevel + 1, this.undos.length);
    this.undos.push(cloneDeep(this.items));
    this.undoLevel = this.undos.length - 1;
  }

  setTemplate(template) {
    this.itemsForTemplate = [];
    this.searchItems(this.items);
    this.itemsForTemplate = [
      ...this.itemsForTemplate,
      ...this.extraItemsForTemplate,
    ];
    let items = cloneDeep(template);
    this.searchItems(items, true);
    this.items = items;
    this.extraItemsForTemplate = cloneDeep(this.itemsForTemplate);
    this.scaffoldChange('template');
  }

  searchItems(viewJson, repopulate?) {
    var $this = this;
    console.log(repopulate, viewJson);
    console.log(JSON.stringify($this.itemsForTemplate));

    if ($this.itemsToFlag.includes(viewJson.type)) {
      if (repopulate) {
        var item;
        let found = false;
        $this.itemsForTemplate.forEach((i, index) => {
          console.log(i.type, viewJson.type);
          if (i.type == viewJson.type && !found) {
            item = i;
            $this.itemsForTemplate.splice(index, 1);
            found = true;
            return false;
          }
        });
        console.log(item);
        if (item) {
          let params = Object.keys(item);
          console.log(params);
          params.forEach(k => {
            console.log('setting', k, 'to', item[k]);
            viewJson[k] = item[k];
          });
        }
      } else {
        $this.itemsForTemplate.push(cloneDeep(viewJson));
      }
    }
    Object.keys(viewJson).forEach(function (key) {
      if (
        $this.toType(viewJson[key]) == 'array' ||
        $this.toType(viewJson[key]) == 'object'
      ) {
        $this.searchItems.call($this, viewJson[key], repopulate);
      }
    });
  }

  toType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  }
}
